import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarButton.scss';
/**
 * A button for our `ActionBar`.
 */ const ActionBarButton = (_param)=>/*#__PURE__*/ {
    var { className , dataHook , children  } = _param, rest = _object_without_properties(_param, [
        "className",
        "dataHook",
        "children"
    ]);
    return React.createElement(PlainButtonOrLink, _extends({
        className: c(s['root'], className),
        "data-hook": dataHook
    }, rest), /*#__PURE__*/ React.createElement(ActionBarItemContentWrapper, null, children));
};
ActionBarButton.displayName = 'ActionBarButton';
export default ActionBarButton;
